import request from '@/utils/request'

export function getMediaById(id) {
  return request({
    url: '/profile/media/'+id,
    method: 'get',
  })
}
export function getLunboImages(params) {
  return request({
    url: '/profile/media/webList',
    method: 'get',
    params: params
  })
}

export function getBanner(params) {
  return request({
    url: '/profile/media/webList',
    method: 'get',
    params: params
  })
}
